export enum LifeCoverageCodes {
  ADDITIONAL_COVERAGE = '999',
}
